import React from 'react';

export const ABeagleContext = React.createContext({});
export const AdsContext = React.createContext();
export const AccountContext = React.createContext({});
